import { COLORS, CREATURES, NAMES, VIBES } from "./model";

export type ProfileDraft = Omit<import("./model").Profile, "id" | "score">;

function pick<T>(list: T[]): T {
  return list[Math.floor(Math.random() * list.length)] as T;
}

export function rollProfile(): ProfileDraft {
  const name = pick(NAMES);
  return {
    name,
    initial: name.slice(0, 1).toUpperCase(),
    color: pick(COLORS),
    creature: pick(CREATURES),
    vibe: pick(VIBES),
  };
}

export function preciseProfile(input: { name: string; color: string; creature: string; vibe: string }): ProfileDraft {
  const name = input.name.trim() || pick(NAMES);
  return {
    name: name.slice(0, 16),
    initial: name.slice(0, 1).toUpperCase(),
    color: /^#[0-9a-fA-F]{6}$/.test(input.color) ? input.color : pick(COLORS),
    creature: input.creature.trim() || pick(CREATURES),
    vibe: input.vibe.trim() || pick(VIBES),
  };
}

export function randomRoomCode(): string {
  const a = pick(NAMES).toLowerCase().replace(/[^a-z]/g, "").slice(0, 6);
  const n = Math.floor(10 + Math.random() * 89);
  return `${a}-${n}`;
}
